import {GraphicsPageComponent } from "../components/graphicsMain"

export const GraphicsPage = () => {
    return (
       <GraphicsPageComponent/>
    )
}